interface SparkleIconProps {
    className?: string;
}

/** Estrelinhas (sparkle) do DS — substitui o PNG de logo no FAB, header e menu de modelo. */
export default function SparkleIcon({ className }: SparkleIconProps) {
    return (
        <svg
            className={className}
            viewBox="28 24 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M49.1667 33.5L50.625 30.2917L53.8333 28.8334L50.625 27.375L49.1667 24.1667L47.7083 27.375L44.5 28.8334L47.7083 30.2917L49.1667 33.5ZM40.4167 34.0834L37.5 27.6667L34.5833 34.0834L28.1667 37L34.5833 39.9167L37.5 46.3334L40.4167 39.9167L46.8333 37L40.4167 34.0834ZM49.1667 40.5L47.7083 43.7084L44.5 45.1667L47.7083 46.625L49.1667 49.8334L50.625 46.625L53.8333 45.1667L50.625 43.7084L49.1667 40.5Z"
                fill="#2F6BED"
            />
        </svg>
    );
}
